import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Select, SelectOption, SelectList } from "@patternfly/react-core/next";
import { MenuToggle } from "@patternfly/react-core";
export var ProductQuantity = function (props) {
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    // const [selected, setSelected] = React.useState<number>(1);
    var options = [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
    ];
    var onToggleClick = function () {
        setIsOpen(!isOpen);
    };
    var onSelect = function (_event, itemId) {
        // setSelected(itemId as number);
        props.onSelectValue(itemId);
        setIsOpen(false);
    };
    var toggle = function (toggleRef) { return (_jsx(MenuToggle, { ref: toggleRef, onClick: onToggleClick, isExpanded: isOpen, style: {
            width: "200px",
        }, children: props.selectedValue })); };
    return (_jsx(Select, { id: "single-select", isOpen: isOpen, selected: props.selectedValue, onSelect: onSelect, onOpenChange: function (isOpen) { return setIsOpen(isOpen); }, toggle: toggle, children: _jsx(SelectList, { children: options.map(function (option, index) { return (_jsx(SelectOption, { itemId: option.value, children: option.label }, index)); }) }) }));
};
